import { Box, Flex, Text } from "@chakra-ui/react";
import React from "react";

import { AiInterviewEvaluationFragment } from "../../../graphql";
import { Citations, CitationsProps } from "./Citations";

type CandidateQuestion = NonNullable<
  AiInterviewEvaluationFragment["candidateQuestions"]
>[number];

type CandidateQuestionsSectionProps = {
  candidateQuestions: CandidateQuestion[];
  citationMap: CitationsProps["citationMap"];
  onPlayMedia?: () => void;
};

const CandidateQuestionsSection: React.FC<CandidateQuestionsSectionProps> = ({
  candidateQuestions,
  citationMap,
  onPlayMedia,
}) => {
  if (!candidateQuestions.length) {
    return null;
  }

  return (
    <Flex direction="column" gap={4} w="100%">
      {candidateQuestions.map((cq) => (
        <Box key={cq.id}>
          <Flex alignItems="flex-start" gap={2} mb={1}>
            <Box
              w="6px"
              h="6px"
              borderRadius="full"
              bg={cq.answered ? "green.400" : "orange.400"}
              flexShrink={0}
              mt="6px"
            />
            <Text fontSize="sm" fontWeight="semibold" color="gray.800">
              {`"${cq.questionText}"`}
            </Text>
          </Flex>
          <Box pl="14px">
            <Text fontSize="sm" color="gray.500" display="inline">
              {cq.answerSummary
                ? cq.answered
                  ? cq.answerSummary
                  : `Unanswered — ${cq.answerSummary}`
                : "No answer summary available."}
            </Text>
            <Citations
              citations={cq.citations}
              citationMap={citationMap}
              onClickTimestamp={onPlayMedia}
            />
          </Box>
        </Box>
      ))}
    </Flex>
  );
};

export default CandidateQuestionsSection;
